(function () {
    'use strict';

    angular.module('doclr.activiteitengroep', ['doclr.resources.api', 'doclr.components.notification', 'doclr.components.colorselector', 'ui.router', 'doclr.disciplines'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('productgroep', {
                    url: '/productgroep/:typeId',

                    resolve: {
                        types: function (EditableBeschikbaarheidTypes, praktijkContext) {
                            return EditableBeschikbaarheidTypes.getList(praktijkContext.id).then(function (types) {
                                return _.sortBy(types, function (type) {
                                    return type.editeerbaar ? 0 : 1;
                                });
                            });
                        },
                        type: function ($stateParams, EditableBeschikbaarheidTypes, types, praktijkContext) {
                            var standaardAdresId = praktijkContext.adressen.filter(function (adres) {
                                return adres.standaard;
                            })[0].id;
                            if ($stateParams.typeId === 'nieuw' || types.length === 0) {
                                return {
                                    eventType: 'groep',
                                    zichtbaarVoorPatient: 'ja',
                                    editeerbaar: true,
                                    metAfspraakmogelijkheden: false,
                                    invulbaarDoorPatient: false,
                                    kleur: '#bee0f9',
                                    metEmail: false,
                                    praktijkAdresId: standaardAdresId,
                                    isActive: true,
                                    multiDiscipline: false
                                };
                            } else if ($stateParams.typeId) {
                                return EditableBeschikbaarheidTypes.load(decodeURIComponent(decodeURIComponent($stateParams.typeId)));
                            } else {
                                return EditableBeschikbaarheidTypes.load(types.filter(type => !!type.isActive).filter(type => type.eventType == 'groep')[0].id);
                            }
                        }
                    },
                    views: {
                        '': {
                            templateUrl: '/partials/components/page.with.sidebar.large.margin.html',
                            controller: function ($scope, $state, $window) {
                                $scope.goToDetail = function (typeId) {
                                    $state.go('productgroep', {typeId: typeId ? encodeURIComponent(encodeURIComponent(typeId)) : null}, {reload: true});
                                    $window.scroll({
                                        top: 0,
                                        behavior: 'smooth'
                                    });
                                };
                            }
                        },
                        'sidebar@productgroep': {
                            templateUrl: '/partials/beschikbaarheidtypes/activiteitengroep.sidebar.html',
                            controller: function ($scope, $state, types, type, borderColor, groupByKey, sortByProperty) {
                                $scope.showInactive = false;
                                $scope.types = types;

                                let activeTypes = types.filter(type => !!type.isActive)
                                    .filter(type => type.eventType == 'groep');
                                let inactiveTypes = types.filter(type => !type.isActive)
                                    .filter(type => type.eventType == 'groep');

                                $scope.groupedActiveTypes = groupAppointmentTypes(activeTypes);
                                $scope.groupedInActiveTypes = groupAppointmentTypes(inactiveTypes);


                                $scope.currentType = type;

                                $scope.isActiefType = function (type) {
                                    return $scope.currentType.id === type.id;
                                };

                                $scope.toggleInactiveTypes = () => $scope.showInactive = !$scope.showInactive;

                                $scope.borderColor = borderColor;

                                $scope.createNew = function () {
                                    $scope.goToDetail('nieuw');
                                };

                                function groupAppointmentTypes(appointmentTypes) {
                                    return groupByKey(appointmentTypes, (type) => type.disciplineName)
                                        .map(group => {
                                            return {
                                                disciplineName: group.key,
                                                types: group.values.sort(sortByProperty(x => doclrVertaal.translateType(x)))
                                            }
                                        })
                                        .sort(sortByProperty(x => x.disciplineName));
                                }
                            }
                        },
                        'content@productgroep': {
                            templateUrl: '/partials/beschikbaarheidtypes/beschikbaarheidtypes.detail.html',
                            resolve: {
                                praktijk: function (Praktijk, praktijkContext) {
                                    return Praktijk.getInfo(praktijkContext.id);
                                },
                                mailOntvangers: function (EditableBeschikbaarheidTypes, praktijkContext, type) {
                                    return EditableBeschikbaarheidTypes.getMailOntvangers(type.id, praktijkContext.id);
                                }
                            },
                            controller: function ($state,
                                                  $scope,
                                                  $q,
                                                  EditableBeschikbaarheidTypes,
                                                  notificationService,
                                                  appContext,
                                                  praktijkContext,
                                                  praktijk,
                                                  type,
                                                  types,
                                                  BeschikbaarheidRelationApi,
                                                  $uibModal,
                                                  mailOntvangers,
                                                  supportedLanguages,
                                                  DoclrModalService) {
                                $scope.disciplineList = appContext.user.allowedDisciplineNames;
                                $scope.appContext = appContext;
                                $scope.eventTypes = ['afspraakMogelijkheid', 'beschikbaarheid']
                                $scope.type = type;
                                $scope.praktijk = praktijk;
                                $scope.praktijkContext = praktijkContext;
                                $scope.isNieuwType = function () {
                                    return !$scope.type.id;
                                };

                                var originalMultiDiscipline = type.multiDiscipline;

                                if (!$scope.isNieuwType()) {
                                    const split = $scope.type.id.split("/");
                                    if (appContext.brandingSettings.publicFlowOptions && appContext.brandingSettings.publicFlowOptions.customPublicFlowUrl) {
                                        $scope.publicUrl = appContext.brandingSettings.publicFlowOptions.customPublicFlowUrl + "/app/groep/" + split[split.length - 1];
                                    } else {
                                        $scope.publicUrl = appContext.publicFeUrl + "/" + appContext.tenantUrlName + "/groep/" + split[split.length - 1];
                                    }
                                }

                                $scope.makeDefault = function () {
                                    DoclrModalService.openConfirmModal(
                                        doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.make.default.popup.title'),
                                        doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.make.default.popup.question'))
                                        .then(() => EditableBeschikbaarheidTypes.setDefault(praktijkContext.id, type.id))
                                        .then(() => $scope.goToDetail(type.id));
                                }


                                type.mailOntvangers = mailOntvangers;

                                function _doSaveWijzigingen() {
                                    EditableBeschikbaarheidTypes.saveWijzigingen(type).then(function () {
                                        notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeUdated'));
                                        $scope.goToDetail(type.id);
                                    });
                                }

                                function _checkNonMutliDisciplineParent() {
                                    const split = type.id.split("/");
                                    const typeId = split[split.length - 1];
                                    return BeschikbaarheidRelationApi.checkNonMutliDisciplineParent(typeId)
                                        .then(function (response) {
                                            if (response.conflicts.length > 0) {
                                                const names = response.conflicts.map(function (x) {
                                                    return x.name;
                                                }).join(', ');
                                                notificationService.showDanger('Deze groep is in gebruik in beschikbaarheden of groepen zonder dienstoverschrijdend: ' + names + '. Verwijder eerst de koppeling voor je dienstoverschrijdend instelt.');
                                            }
                                            return response.conflicts;
                                        });
                                }

                                function _checkMutliDisciplineChild() {
                                    const split = type.id.split("/");
                                    const typeId = split[split.length - 1];
                                    return BeschikbaarheidRelationApi.checkMutliDisciplineChild(typeId)
                                        .then(function (response) {
                                            if (response.conflicts.length > 0) {
                                                const names = response.conflicts.map(function (x) {
                                                    return x.name;
                                                }).join(', ');
                                                notificationService.showDanger('Deze groep heeft nog producten of groepen gelinked: ' + names + '. Verwijder eerst de koppeling voor je dienstoverschrijdend uitzet.');
                                            }
                                            return response.conflicts;
                                        });
                                }

                                $scope.onMultiDisciplineChange = function () {
                                    if (type.multiDiscipline && !originalMultiDiscipline && type.id) {
                                        _checkNonMutliDisciplineParent().then(conflicts => {
                                            if (conflicts.length > 0) {
                                                type.multiDiscipline = false;
                                            }
                                        });
                                    }

                                    if (!type.multiDiscipline && originalMultiDiscipline && type.id) {
                                        _checkMutliDisciplineChild().then(conflicts => {
                                            if (conflicts.length > 0) {
                                                type.multiDiscipline = true;
                                            }
                                        });
                                    }
                                };

                                $scope.bewaren = function () {
                                    if ($scope.isNieuwType()) {
                                        EditableBeschikbaarheidTypes.saveNieuwType(praktijkContext.id, type).then(function (nieuweType) {
                                            notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeCreated'));
                                            $scope.goToDetail(nieuweType.id);
                                        });
                                        return;

                                    }
                                    if (type.multiDiscipline && !originalMultiDiscipline) {
                                        _checkNonMutliDisciplineParent().then(function (conflicts) {
                                            if (conflicts.length === 0) {
                                                type.disciplineName = undefined;
                                                _doSaveWijzigingen();
                                            }
                                        });

                                        return;
                                    }

                                    if (!type.multiDiscipline && originalMultiDiscipline) {
                                        _checkMutliDisciplineChild().then(function (conflicts) {
                                            if (conflicts.length === 0) {
                                                _doSaveWijzigingen();
                                            }
                                        });

                                        return;
                                    }

                                    _doSaveWijzigingen();

                                };

                                $scope.verwijderen = function () {
                                    $scope.confirmmodal = {
                                        title: doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.deleteTypeTitle'),
                                        question: doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.deleteTypeQuestion', {name: type.naam})
                                    };

                                    var modalInstance = $uibModal.open({
                                        templateUrl: '/partials/components/confirmmodal.html',
                                        scope: $scope
                                    });

                                    modalInstance.result.then(function () {
                                        EditableBeschikbaarheidTypes.verwijder(type).then(
                                            function () {
                                                notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeDeleted'));
                                                $state.go('productgroep', {typeId: null});
                                            }
                                        );
                                    });
                                };

                                $scope.reload = function () {
                                    $scope.goToDetail($scope.type.id);
                                };
                            }
                        }
                    }

                });
        });
})();